import {Component, EventEmitter, Input, Output} from "@angular/core";
import {RestrictionsResponseData} from "../../framework/bi/restrictions-response.data";

@Component({
    selector: "wbo-bi-view-page-header",
    templateUrl: "./view-page-header.component.html",
    styleUrls: ["./view-page-header.component.scss"]
})
export class ViewPageHeaderComponent {
    @Input() showRefresh: boolean = true;

    @Input() showEdit: boolean = false;

    @Input() showClone: boolean = false;

    @Input() showDelete: boolean = false;

    @Input() restrictions: RestrictionsResponseData;

    @Input() rowsTruncated: number;
    @Input() columnsTruncated: number;

    @Output() refresh: EventEmitter<any> = new EventEmitter<any>();

    @Output() edit: EventEmitter<any> = new EventEmitter<any>();

    @Output() delete: EventEmitter<any> = new EventEmitter<any>();

    @Output() clone: EventEmitter<any> = new EventEmitter<any>();
}
